import React from "react";
// import { cityCount, tutorCount, userCount } from "../../../utils/constants";

const Reach = () => {
  return (
    <div className="mt-6 mb-6 flex flex-row justify-center">
    <div className="text-center px-6" style={{borderRight: "1px solid rgba(230, 230, 230, 1)"}}>
      <p className="colorBlue md:text-xl sm:text-l font-bold leading-10">3000+</p>
      <span>Cities</span>
    </div>
    <div className="text-center px-6" style={{borderRight: "1px solid rgba(230, 230, 230, 1)"}}>
      <p className="colorBlue md:text-xl sm:text-l leading-10">1 Lakh+</p>
      <span>Teachers</span>
    </div>
    <div className="text-center px-6">
      <p className="colorBlue md:text-xl sm:text-l font-bold leading-10">1 Crore+</p>
      <span>Students</span>
    </div>
  </div>
  );
};

export default Reach;
